export const WA_NUMBER = "6282312373010";

export const waLink = (message) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

export const CONTACT = {
  cs1: "082312373010",
  cs2: "085186862084",
  email: "connect@sinovarcargo.com",
};

export const ASSETS = {
  mark: "/sinovar-mark.png",
  heroScene:
    "https://static.prod-images.emergentagent.com/jobs/81869e82-b3fc-4998-8d1d-25892b87cbe9/images/45300d9608665115cae4ededd21e515288f6a95cf4e8966da4f82db9cf20da5e.jpeg",
  worldMap: "/asia-map.png",
  sendlinkProducts:
    "https://static.prod-images.emergentagent.com/jobs/81869e82-b3fc-4998-8d1d-25892b87cbe9/images/edb49abbd2adb1b05d787f428f6f3bf1f140e34b81d5208dafed3267f965ae46.jpeg",
  lbsProducts:
    "https://static.prod-images.emergentagent.com/jobs/81869e82-b3fc-4998-8d1d-25892b87cbe9/images/7dc9bfef40b055aa48a5d97582344dd4c0b4175e32e3238f17f756b50e39944a.jpeg",
  heroBusiness:
    "https://static.prod-images.emergentagent.com/jobs/81869e82-b3fc-4998-8d1d-25892b87cbe9/images/3fd2e4cc2a7f41ae327e2e53a82fdfa5417ea0216a54a442738d2268c4054f6b.jpeg",
  productSpotlight:
    "https://static.prod-images.emergentagent.com/jobs/81869e82-b3fc-4998-8d1d-25892b87cbe9/images/a23bcd07294379dd3cf96dabb2e07f2486c2e0f581d258864b49fd526bbab0b9.jpeg",
  tradeRoute:
    "https://static.prod-images.emergentagent.com/jobs/81869e82-b3fc-4998-8d1d-25892b87cbe9/images/9643db41f347f3fb921c4137da0aa1240af2fe9cddd67f014bc8fa8fb4383a73.jpeg",
  businessMeeting:
    "https://images.unsplash.com/photo-1577415124269-fc1140a69e91?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  groupMeeting:
    "https://images.unsplash.com/photo-1731458769726-cef60c792665?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  factory:
    "https://images.unsplash.com/photo-1642979904576-408d8e8ea8c9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  negotiation:
    "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  warehouse:
    "https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  boxes:
    "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  ship:
    "https://images.unsplash.com/photo-1769144256207-bc4bb75b29db?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  retail:
    "https://images.unsplash.com/photo-1777136977034-71cbc026c9b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
